import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { appNotificationStyles } from "styles/appNotifications";
import App from "./App";
import "./assets/fonts/fonts.css";
import ApolloProvider from "./graphql/apollo";
import theme from "./theme";

const useStyles = makeStyles(appNotificationStyles);

async function enableMocking() {
  if (process.env.REACT_APP_ENVIRONMENT !== "test") {
    return;
  }

  const serverModule = await import("./tests/mocks/server");
  const { worker } = serverModule;

  if (!worker) {
    return;
  }

  // @ts-expect-error - expose worker for e2e tests
  window.msw = { worker };

  return worker.start({
    onUnhandledRequest: "bypass",
  });
}

const Providers = () => {
  const classes = useStyles();
  return (
    <ApolloProvider>
      <BrowserRouter>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            classes={classes}
            autoHideDuration={3000}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <DndProvider backend={HTML5Backend}>
              <App />
            </DndProvider>
          </SnackbarProvider>
        </MuiThemeProvider>
      </BrowserRouter>
    </ApolloProvider>
  );
};

const container = document.getElementById("root");
const root = createRoot(container!);

enableMocking().then(() => {
  root.render(<Providers />);
});
